import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function TransactionsChart({ data = [] }) {
  return (
    <div className="w-full h-[350px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid
            strokeDasharray="3 3"
            className="stroke-gray-200 dark:stroke-gray-700"
          />

          <XAxis
            dataKey="name"
            className="text-xs fill-gray-600 dark:fill-gray-300"
          />

          <YAxis className="text-xs fill-gray-600 dark:fill-gray-300" />

          <Tooltip
            contentStyle={{
              backgroundColor: "rgb(31 41 55)",
              border: "none",
              borderRadius: "8px",
            }}
          />

          <Legend />

          <Line
            type="monotone"
            dataKey="SKINET"
            stroke="#3b82f6"
            strokeWidth={3}
            dot={false}
          />

          <Line
            type="monotone"
            dataKey="DUITKU"
            stroke="#22c55e"
            strokeWidth={3}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
